import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _assertThisInitialized from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _wrapNativeSuper from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _objectSpread from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";

function runCompat(endpoint, options) {
  endpoint.type = endpoint.sideEffect ? 'mutate' : 'read';
  endpoint.options = _objectSpread({}, options);
  delete endpoint.options.key;
  delete endpoint.options.schema;
  delete endpoint.options.sideEffect;
  delete endpoint.options.fetch;
  delete endpoint.options.getFetchKey;
  delete endpoint.options.options;

  if (Object.keys(endpoint.options).length === 0) {
    delete endpoint.options;
  }

  if (endpoint.schema === undefined) endpoint.schema = null;
}

var CSP = false;

try {
  Function();
} catch (e) {
  /* istanbul ignore next */
  CSP = true;
}
/**
 * Defines an async data source.
 * @see https://resthooks.io/docs/api/Endpoint
 */


var Endpoint = /*#__PURE__*/function (_Function) {
  _inherits(Endpoint, _Function);

  var _super = _createSuper(Endpoint);

  function Endpoint(fetchFunction, options) {
    var _this;

    _classCallCheck(this, Endpoint);

    var _self2; // TODO: Test the fallback?

    /* istanbul ignore if */

    /* istanbul ignore next */


    if (CSP) {
      _self2 = function self() {
        var _self;

        return (_self = _self2).fetch.apply(_self, arguments);
      };

      Object.setPrototypeOf(_self2, (this instanceof Endpoint ? this.constructor : void 0).prototype);
    } else {
      _this = _super.call(this, 'return arguments.callee.fetch.apply(arguments.callee, arguments)');
      _self2 = _assertThisInitialized(_this);
    }
    /** The following is for compatibility with FetchShape */


    _self2.getFetchKey = function (params) {
      return _self2.key(params);
    };

    if (fetchFunction) _self2.fetch = fetchFunction;

    if (options && 'name' in options) {
      _self2.__name = options.name;
      delete options.name;
    } else if (fetchFunction) {
      _self2.__name = fetchFunction.name;
    }

    Object.assign(_self2, options);
    Object.defineProperty(_self2, 'name', {
      get: function get() {
        return this.__name;
      }
    });
    /** The following is for compatibility with FetchShape */

    runCompat(_self2, options);
    return _possibleConstructorReturn(_this, _self2);
  }

  _createClass(Endpoint, [{
    key: "key",
    value: function key() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return "".concat(this.name, " ").concat(JSON.stringify(args));
    }
  }, {
    key: "bind",
    value: function bind(thisArg) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      var fetchFunc = this.fetch;
      var keyFunc = this.key;
      return this.extend({
        fetch: function fetch() {
          return fetchFunc.apply(thisArg != null ? thisArg : this, args);
        },
        key: function key() {
          return keyFunc.apply(this, args);
        }
      });
    }
  }, {
    key: "extend",
    value: function extend(options) {
      // make a constructor/prototype based off this
      // extend from it and init with options sent
      var E = /*#__PURE__*/function (_this$constructor) {
        _inherits(E, _this$constructor);

        var _super2 = _createSuper(E);

        function E() {
          _classCallCheck(this, E);

          return _super2.apply(this, arguments);
        }

        return _createClass(E);
      }(this.constructor);

      Object.assign(E.prototype, this);
      var instance = new E(options.fetch, options);
      /** The following is for compatibility with FetchShape */

      runCompat(instance, _objectSpread(_objectSpread({}, this.options), options));
      return instance;
    }
  }]);

  return Endpoint;
}( /*#__PURE__*/_wrapNativeSuper(Function));

export { Endpoint as default };